<div bsModal #editRentModal="bs-modal" [config]="modalConfig" class="modal fade" id="EditRent" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Rent</h5>
        <button type="button" class="close" aria-label="Close" (click)="onCancel(); closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <label>Rent@if (curentRentField) {
              <span class="required">*</span>
            }</label>
            <input type="text" class="form-control" [value]="curentRent | currency" readonly />
          </div>
          <div class="col-md-6 pt-3 pt-md-0">
            <label>Modified Rent@if (modifiedRentField) {
              <span class="required">*</span>
            }</label>
            <input type="text" class="form-control" [(ngModel)]="modifiedRent"
              [disabled]="checkDisabledForModifiedRent()" (input)="onModifiedRentChange($event.target.value)"
              (keypress)="numberOnly($event)" (blur)="isdisabledsave();setCurrency()" (paste)="$event.preventDefault()"
              #modifiedRentField="ngModel" />
              @if (RentDisplayMessage) {
                <div class="alert alert-danger">
                  <span>
                    {{RentDisplayMessage}}
                  </span>
                </div>
              }
            </div>
          </div>
          @if (miscelleaneousSetting?.DisplayBudgetedRent && this.budgetedRent != null) {
            <div class="col-md-6 pt-3 ms-2">
              <label>Budgeted Rent:</label>
              <span> {{ this.budgetedRent | currency }}</span>
            </div>
          }
            @if (unitTypeId) {
            <div class="row mt-3">
              <label>Competitor Rate</label>
              @if (competitorMarketRate?.IsMatched) {
              <span>{{competitorMarketRate.AverageOccupiedRent | currency}}</span>
              <span class="list-icon" style="cursor:pointer;" title="View competitor rates"
                    (click)="openCompetitorRateDetail(competitorRateDetailModal)"></span>
              } @else {
              <span>No competitor rate</span>
              }
            </div>
            }
          <div class="row mx-0 mt-3">
            <label>Note@if (editedRentNoteField !== null && curentRent != modifiedRent) {
              <span
              class="required">*</span>
            }</label>
            <textarea rows="5" class="form-control" [(ngModel)]="editedRentNote" #noteField="ngModel"
            (keypress)="clearValidationMessage()"></textarea>
            @if (modifiedRent != curentRent && editedRentNoteField && noteField.touched && editedRentNote === '') {
              <div class="alert alert-danger"
                >
                <span>
                  Note is required!
                </span>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary me-3"
          (click)="onCancel(); closeModal()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="getDisabledForRentPopup()"
          (click)="emitEditedRent(); closeModal()">Save</button>
        </div>
      </div>
    </div>
  </div>

<ng-template #competitorRateDetailModal>

  <div class="modal-header">
    <h5 class="modal-title">Competitor Rates</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="competitorRateModalRef?.hide()"></button>
  </div>
  <div class="modal-body">
    <app-competitor-rate-detail-list [competitorRates]="selectedCompetitorRates"></app-competitor-rate-detail-list>
  </div>
</ng-template>

